import React from 'react';
import './Main_plan.css';

import {Helmet} from "react-helmet";

import Plan from '../Plan/Plan.js';
import MasterButton from '../../general_components/MasterButton/MasterButton.js';

import GGApi from '../../../utils/GGApi.js';
import GG_loader from '../../general_components/GG_loader/GG_loader';
import Overlay_popup from '../../general_components/Overlay_popup/Overlay_popup';
import Share_overlay_buttons from '../../general_components/Share_overlay_buttons/Share_overlay_buttons';

import plan_and_goal from '../../../images/illustrations/goals_and_plans.svg';

import { getGiftingPageUrl, getGiveAGiftShareUrl } from '../../../utils/gifting_page_share';
import { logShareClick, logShareOverlayOpen } from '../../../utils/shareAnalytics';
import { logEvent } from '../../../utils/analytics';
 
class Main_plan extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            open_overlay: '',
            overlay_index: 0,
            plans: [],
            child: '',
            slug: '',
            wf_item_id: null,
            welcome_message: ''
            /*
            id
            user_id
            account_name
            birthday
            banner_picture

            account_id
            goal_name 
            target_savings
            target_date
            fund_id

            account_id
            fund_type
            fund_institution
            fund_number_or_api_id
            fund_amount

            */
        };

        this.renderPlans = this.renderPlans.bind(this);
        this.share_button = this.share_button.bind(this);
        this.link_button = this.link_button.bind(this);
        this.link_button_2 = this.link_button_2.bind(this);
        this.copy_to_clipboard = this.copy_to_clipboard.bind(this);
        this.logShareChannel = this.logShareChannel.bind(this);
    }
    
    componentDidMount() {
        GGApi.get_plans().then(fetched_plans => {
            this.setState({plans: fetched_plans, loading: false});
            logEvent('plan: view plan list', {
                source: 'plan_list',
                plan_count: fetched_plans.length,
            });
        });
    }

    share_button(plan_id, link_to, shareSource = 'plan_list'){
        let index = this.state.plans.findIndex(plan_list_item => plan_list_item.id === plan_id);
        if (index === -1) return;

        const share_type = link_to === 'link' ? 'give_a_gift_link' : 'registry_link';
        logShareClick({ source: shareSource, share_type, plan_id });
        logShareOverlayOpen({ source: shareSource, share_type, plan_id });

        if (link_to === 'link') {
            this.setState({
                open_overlay: true,
                overlay_index: index,
                child: this.state.plans[index].account_name,
            });
        } else if (link_to === 'gifting page') {
            this.setState({
                open_overlay_2: true,
                overlay_index: index,
                child: this.state.plans[index].account_name,
                slug: this.state.plans[index].slug,
                wf_item_id: this.state.plans[index].wf_item_id,
                welcome_message: this.state.plans[index].welcome_message,
                share_plan_id: plan_id,
            });
        }
    }

    copy_to_clipboard(){
        /* clipboard successfully set */
        alert('The link was successfully copied!');
        this.setState({open_overlay: false, open_overlay_2: false});
    }

    link_button(){
        let user = JSON.parse(localStorage.getItem('user'));
        navigator.clipboard.writeText(getGiveAGiftShareUrl(this.state.child, user))
            .then(this.copy_to_clipboard, function() {
                /* clipboard write failed */
                alert('There was an issue when attempting to copy the link.');
            })

    }


    link_button_2(){
        navigator.clipboard.writeText(getGiftingPageUrl(this.state.slug, this.state.wf_item_id))
            .then(this.copy_to_clipboard, function() {
                /* clipboard write failed */
                alert('There was an issue when attempting to copy the link.');
            })

    }

    logShareChannel(channel) {
        logEvent('gifting page: select share channel', { channel, source: 'plan_page' });
    }

    renderPlans(){
        return this.state.plans.map(plan => {
            return <Plan
                        key={plan.id}
                        name={plan.account_name}
                        saved_to_date={plan.total_redeemed ? plan.total_redeemed : '0'}
                        redeemed_gifts={plan.redeemed_gifts ? plan.redeemed_gifts : '0'}
                        banner_pic={plan.media_url}
                        plan_id={plan.id}
                        target_savings={plan.target_savings}
                        share_button={this.share_button}
                        page_active={plan.page_active}
                        slug={plan.slug}
                        has_gift_matching={!(plan.matching_programs_count == null || plan.matching_programs_count === 0)}
                        /> ;
            });
    }



    render () {
        if(this.state.loading) {
            return (
                <GG_loader />
            )
        }

        let user = JSON.parse(localStorage.getItem('user'));

        return (
            <main>
                <Helmet>
                    <title>{`Recipients & Plans | Greatest Gift`}</title>
               </Helmet>

                {this.state.plans.length !== 0 ? null : <h2>Create a plan, set goals, and track savings</h2>}
                {this.state.plans.length !== 0 ? null :
                    <div className='main_plan_illustration_container'>
                        <img className='main_plan_illustration' src={plan_and_goal}/>
                    </div>
                }
                {this.renderPlans()}
                

                <MasterButton 
                    buttonText='add a recipient account' 
                    links={true}
                    linkTo='/add_account'
                    notSticky={true}
                />
                <div className='buffer'></div>


                <Overlay_popup 
                open={this.state.open_overlay}
                closer={true}
                handleClose={() => this.setState({open_overlay: false})}
                overlay_title='Share'
                
                body_1={`Let your friends and family know you are saving for ${this.state.child}'s future and send them a link so they can start sending ${this.state.child} gifts.`}
                joker={
                    <Share_overlay_buttons
                        childName={this.state.child}
                        shareUrl={getGiveAGiftShareUrl(this.state.child, user)}
                        onCopyLink={this.link_button}
                        onChannelSelect={this.logShareChannel}
                    />
                }/>

                <Overlay_popup 
                open={this.state.open_overlay_2}

                closer={true}
                handleClose={() => this.setState({open_overlay_2: false})}
                overlay_title='Share Gifting Page'
                
                body_1={`Let your friends and family know you are saving for ${this.state.child}'s future.`}
                joker={
                    <Share_overlay_buttons
                        childName={this.state.child}
                        shareUrl={getGiftingPageUrl(this.state.slug, this.state.wf_item_id)}
                        nativeShareMessage={this.state.welcome_message || undefined}
                        onCopyLink={this.link_button_2}
                        onChannelSelect={this.logShareChannel}
                        accountId={this.state.share_plan_id}
                        qrSource='plan_list'
                    />
                }/>

            </main>
        );
    }
}

export default Main_plan;